import { Component, ElementRef, Input, OnChanges, Renderer2 } from "@angular/core";
import './v-tiles.component.scss';

@Component({
    selector: 'v-tiles',
    template: require('./v-tiles.component.html')
})
export class VTilesComponent implements OnChanges {
    @Input() cols: number;

    constructor(private readonly renderer: Renderer2, private readonly el: ElementRef) {
    }

    ngOnChanges(): void {
        if (this.cols) {
            this.renderer.addClass(this.el.nativeElement, "cols-" + this.cols);
        }
    }
}
